import { motion } from "framer-motion";
import * as React from "react";
import { FC, useContext, useState } from "react";
import { ViewContext } from "../constants/context.ts";
import { slideUp } from "../constants/framer.config.ts";

interface FrequentlyAskedQuestionsProps {
  textColor: "black" | "white";
}

const MinusIcon: React.FC = () => (
  <svg width="17" height="3" viewBox="0 0 22 4" fill="none" className="m-0 p-0">
    <path
      d="M0 0.0918355L0 3.91431L22 3.91431V0.0918355L0 0.0918355Z"
      fill="#31BACF"
    />
  </svg>
);

const PlusIcon: React.FC = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 22 22"
    fill="none"
    className="m-0 p-0"
  >
    <path
      d="M22 9.08733H12.9127V0H9.08733V9.08733H0V12.9127H9.08733V22H12.9127V12.9127H22V9.08733Z"
      fill="#31BACF"
    />
  </svg>
);

interface IconToggleProps {
  isOpen: boolean;
}

const IconToggle: React.FC<IconToggleProps> = ({ isOpen }) => {
  return isOpen ? <MinusIcon /> : <PlusIcon />;
};

const FrequentlyAskedQuestions: FC<FrequentlyAskedQuestionsProps> = ({
  textColor,
}) => {
  const { showView } = useContext(ViewContext);
  const textClass = textColor === "black" ? "text-black" : "text-[#E3FFFF]";
  const [openPanels, setOpenPanels] = useState<Record<number, boolean>>({});

  const togglePanel = (index: number) => {
    setOpenPanels((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const panels = [
    {
      title: "How Does it Work?",
      content:
        "Once you purchase a plan you are prompted with a link to get instant access to our 2 premium indicators directly on your TradingView charts. It works fully on the free plan of TradingView. You will also be able to connect your Discord account to join our members area, a full community experience, and active product updates. If you're having any issues, email your usernames to support@unityacademy.com.",
    },
    {
      title: "What markets can I use it with?",
      content:
        "Once you purchase a plan you are prompted with a link to get instant access to our 2 premium indicators directly on your TradingView charts. It works fully on the free plan of TradingView. ‍ You will also be able to connect your Discord account to join our members area, a full community experience, and active product updates. If you're having any issues, email your usernames to support@unityacademy.com.",
    },
    {
      title: "Can I win every trade using this?",
      content:
        'Absolutely not. There is no indicator, "algorithm", "system", or strategy to give you the power to predict markets with a guaranteed % accuracy. ‍ The premium indicators cannot guarantee you profits or make you a better trader / investor alone. ‍ We do not recommend blindly following any indicator. Trading itself is risky, most day traders lose money, and past performance does not guarantee future results.',
    },
  ];

  return (
    <motion.div {...slideUp(showView)}>
      <div className="flex flex-col w-full max-w-6xl px-6 sm:px-8 md:px-12 lg:px-14 xl:px-16 m-auto mt-5 py-10 sm:py-14 md:py-16">
        <div
          className={`text-[70px] max-lg:text-4xl ${textClass} font-bold mx-auto mb-8 text-center`}
        >
          FAQs
        </div>

        <div className="border-none w-full duration-75 transition-all px-1 md:px-6">
          {panels.map((panel, index) => (
            <div key={index}>
              <div className="mb-2">
                <button
                  className={`w-full text-left py-7 focus:bg-transparent bg-transparent hover:bg-transparent ${textClass} text-lg font-medium flex items-center gap-2`}
                  onClick={() => togglePanel(index)}
                >
                  <IconToggle isOpen={!!openPanels[index]} />
                  <span className="flex-1 text-left">{panel.title}</span>
                </button>
                {openPanels[index] && (
                  <div
                    className={`${textClass} font-light leading-6 self-stretch max-md:max-w-full pb-4 pl-14`}
                  >
                    {panel.content}
                  </div>
                )}
              </div>
              <div className="w-full h-px bg-[#272727] mb-2" />
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default FrequentlyAskedQuestions;
